import React, { useContext, useState } from 'react';
import { MediaImageFromLinkView, MediaImageFromLinkViewProps } from './MediaImageFromLink.view';
import { PostEditorContext } from '../states/PostEditorProvider';
import { PostEditorGroupDataContext } from '../states/PostEditorGroupDataProvider';
import { ActiveCustomizeIndexContext } from '../states/ActiveCustomizeIndexProvider';
import { showToast } from '../../../helpers/showToast';
import { cloneDeep } from 'lodash';

export type MediaImageFromLinkControllerProps = {
  uploadHandler: (urls: string[]) => void;
};

export type SelectedImagesFromLinkType = {
  index: number;
  url: string;
};

export const MediaImageFromLinkController = (props: MediaImageFromLinkControllerProps): JSX.Element => {
  const { uploadHandler } = props;
  // Put All your methods and logic here
  const { state } = useContext(PostEditorContext);
  const [postGroupDataState] = useContext(PostEditorGroupDataContext);
  const { postGroupIndex } = postGroupDataState;
  const postGroup = state.postGroups[postGroupIndex];
  const customizeIndex = useContext(ActiveCustomizeIndexContext);
  const { customizeContentPerProfile, posts } = postGroup;
  const isCustomByProfile = customizeContentPerProfile && typeof customizeIndex === 'number';
  const [selectedImages, setSelectedImages] = useState<SelectedImagesFromLinkType[]>([]);

  const addImagesHandler = () => {
    const urls = selectedImages.map(item => item.url);
    uploadHandler(urls);
  };

  const selectHandler: MediaImageFromLinkViewProps['selectHandler'] = (index, e) => {
    e.preventDefault();
    const image = imageUrls[index] ? { index, url: imageUrls[index] } : null;
    if (!image) {
      showToast({
        summary: 'Selecting Image Failed',
        detail: 'Mapping image error. Please try again',
        severity: 'warn'
      });
      return;
    }
    setSelectedImages(old => {
      const selectedIndex = old.findIndex(item => item.index === index);
      if (selectedIndex > -1) {
        const copiedOld = cloneDeep(old);
        copiedOld.splice(selectedIndex, 1);
        return copiedOld;
      } else {
        return [...old, image];
      }
    });
  };

  const link = isCustomByProfile ? posts[customizeIndex].content.link : postGroup.groupPostAttributes.content.link;
  if (!link) return <></>;
  const loading = link.linkMetadata === undefined;
  const imageUrls = link.linkMetadata?.images || [];
  const viewProps: MediaImageFromLinkViewProps = {
    loading,
    imageUrls,
    selectHandler,
    addImagesHandler,
    selectedImages
  };
  return <MediaImageFromLinkView {...viewProps} />;
};
